var React = require('react');

function Schwyz (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"fill":"#E8423F","d":"M.299.061h468.209V469.86H.299z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M25.519 94.142v22.948h69.966v69.982h22.932V117.09h69.967V94.142h-69.967V24.173H95.485v69.969z","key":1})]));
}

Schwyz.defaultProps = {"viewBox":"0 0 469 470"};

module.exports = Schwyz;

Schwyz.default = Schwyz;
